module.exports = __webpack_public_path__ + "img/drc-text.ece1ce4c.svg";